import axiosInstance from "../api";
import { notification } from "antd";


export const getCmsConfigurations = async () => {
    try {
      const response = await axiosInstance.get(
        `/get_cms_configurations`
      );
  
      if (response?.data?.status_code === 200) {
        return response?.data?.data;
      }
      notification.error({
        message: "Error Fetching data",
        description:
          response?.data?.message || "Failed to fetch data list.",
        duration: 3,
      });
    } catch (error) {
      notification.error({
        message: "Error Fetching data",
        description:
          error.response?.data?.message || "Failed to fetch data list.",
        duration: 3,
      });
    }
  };


  export const updateCmsConfigurations = async (data) => {
    try {
      const formData = new FormData();
      if (data.use_custom !== undefined) {
        formData.append("use_custom", data.use_custom);
      }
      if (data.custom_value !== undefined) {
        formData.append("custom_value", data.custom_value);
      }
      if (data.value_json !== undefined) {
        formData.append("value_json", JSON.stringify(data.value_json));
      }
      if (data.image !== undefined) {
        formData.append("image", data.image);
      }
      if (data.is_delete_image !== undefined) {
        formData.append("is_delete_image", data.is_delete_image);
      }
      if (data.id) {
        formData.append("id", data.id);
      }
  
      const response = await axiosInstance.put(
        `/update_cms_configurations`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      if (response.data.status_code === 200) {
        notification.success({
          message: "Success",
          description: response.data.message,
          duration: 3,
        });
        return response.data.data;
      } else {
        notification.error({
          message: "Update Error",
          description:
            response.data.message ||
            "An error occurred while updating CMS Configurations.",
          duration: 3,
        });
      }
    } catch (error) {
      notification.error({
        message: "Update Failed",
        description:
          error.response?.data?.message || "An unexpected error occurred.",
        duration: 3,
      });
      throw new Error(
        error.response?.data?.message || "Error updating CMS Configurations"
      );
    }
  };


  export const updateMultipleCmsConfigurations = async (data) => {
    try {
    
      const response = await axiosInstance.put(
        `/update_cms_configurations_multiple`, data);
  
      if (response.data.status_code === 200) {
        notification.success({
          message: "Success",
          description: response.data.message,
          duration: 3,
        });
        return response.data.data;
      } else {
        notification.error({
          message: "Update Error",
          description:
            response.data.message ||
            "An error occurred while updating CMS Configurations.",
          duration: 3,
        });
      }
    } catch (error) {
      notification.error({
        message: "Update Failed",
        description:
          error.response?.data?.message || "An unexpected error occurred.",
        duration: 3,
      });
      throw new Error(
        error.response?.data?.message || "Error updating CMS Configurations"
      );
    }
  };

  export const updateCmsConfigurationsBanner = async (data) => {
    try {
      const formData = new FormData();
    
      if (data.image) {
        formData.append("image", data.image);
      }
      if (data.id) {
        formData.append("id", data.id);
      }
      if (data.use_custom !== undefined) {
        formData.append("use_custom", data.use_custom);
      }
      if (data.is_delete_image !== undefined) {
        formData.append("is_delete_image", data.is_delete_image);
      }
  
      const response = await axiosInstance.put(
        `/update_cms_configurations`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      if (response.data.status_code === 200) {
       
        return response.data.data;
      } else {
        notification.error({
          message: "Update Error",
          description:
            response.data.message ||
            "An error occurred while updating CMS Configurations.",
          duration: 3,
        });
      }
    } catch (error) {
      notification.error({
        message: "Update Failed",
        description:
          error.response?.data?.message || "An unexpected error occurred.",
        duration: 3,
      });
    }
  };
